<template>
  <div class="container">
    <div class="page-title">
      <h2 class="title__h2">Contactame</h2>
    </div>
    <section class="contact-container">
      <div class="contact-header">
        <h2 class="contact__h2">¿Quieres Conocer Más Sobre Mi?</h2>
        <h4 class="contact_h4">Contrata Mis Servicios</h4>
      </div>
      <div class="contact-content">
        <div class="contact-icons contact-side-content">
          <div :key="item" v-for="item in info">
            <i
              class="contact-icons__i"
              :class="item.icon"
              aria-hidden="true"
            ></i>
            <h4 class="contact_title">{{ item.name }}</h4>
            <p class="contact-icons__p">
              <a v-if="item.link" target="__blank" :href="item.data">{{
                item.data
              }}</a>
              <span v-else>{{ item.data }}</span>
            </p>
          </div>
        </div>
        <div class="contact-form contact-side-content">
          <form class="contact-form__form">
            <div class="input-container">
              <label for="name"> Nombre:</label>
              <input
                class="contact-form__input"
                type="text"
                name="name"
                placeholder="Nombre"
                required=""
                v-model="emailContent.name"
              />
            </div>
            <div class="input-container">
              <label for="email"> Correo: </label>
              <input
                class="contact-form__input"
                name="email"
                type="text"
                placeholder="Email"
                required=""
                v-model="emailContent.email"
              />
            </div>

            <div class="input-container">
              <label for="subject"> Asunto: </label>
              <input
                name="subject"
                class="contact-form__input contact-form__input--subject"
                type="text"
                placeholder="Asunto"
                required=""
                v-model="emailContent.suggest"
              />
            </div>

            <div class="input-container input-container__textarea">
              <label for="message"> Mensaje: </label>
              <textarea
                name="message"
                class="contact-form__textarea"
                cols="20"
                rows="10"
                placeholder="Mensaje"
                required=""
                v-model="emailContent.message"
              ></textarea>
            </div>

            <div class="contact-button">
              <button @click="sendEmail" class="contact-form__button">
                Enviar Mensaje
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import emailjs from "emailjs-com";
export default {
  name: "ContactView",
  data() {
    return {
      info: [
        {
          name: "Ubicacion",
          icon: "fas fa-map-marker-alt",
          data: "Anzoátegui - Barcelona",
          link: false,
        },
        {
          name: "Correo",
          icon: "fas fa-envelope",
          data: "amilcar.coronado64@gmail.com",
          link: false,
        },
        {
          name: "Github",
          icon: "fab fa-github",
          data: "https://github.com/amilcarex",
          link: true,
        },
      ],
      emailContent: {
        name: null,
        email: null,
        suggest: null,
        message: null,
      },
    };
  },
  methods: {
    sendEmail(event) {
      event.preventDefault();
      if (this.emailContent.email.indexOf("@") == -1) {
        this.$swal({
          title: "Error",
          html: "<p>Debe ser un Correo Válido</p>",
          icon: "error",
          confirmButtonClass: "button-alerta",
          confirmButtonText:
            "<span class='alerta'>Entiendo</span>",
        });
        return;
      } else {
        emailjs
          .send(
            "service_ac8z5co",
            "template_ktgnwpj",
            this.emailContent,
            "user_rvdrnYx1xlC2PLDxWcyaL"
          )
          .then(
            () => {
              this.$swal({
                title: "Enviado",
                html: "<p>Correo ha sido enviado Correctamente</p>",
                icon: "success",
                confirmButtonClass: "button-alerta",
                confirmButtonText:
                  "<span class='alerta'>Entiendo <i class='fas fa-thumbs-up'></i> </span>",
              });
              this.emailContent.name = null;
              this.emailContent.email = null;
              this.emailContent.suggest = null;
              this.emailContent.message = null;
            },
            () => {
              this.$swal({
                title: "Error",
                html: "<p>Su correo no pudo ser enviado</p>",
                icon: "error",
                confirmButtonClass: "button-alerta",
                confirmButtonText:
                  "<span class='alerta'>Entiendo <i class='fas fa-thumbs-up'></i> </span>",
              });
            }
          );
      }
    },
  },
};
</script>

<style>
</style>